import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TableDialogModel } from '@pg-app/partner/dashboard/model/table-dialog.model';

@Injectable({
  providedIn: 'root'
})
export class TableDialogService {
  public TableDialogSubject = new Subject<TableDialogModel>();
  public TableTabSelectedSubject = new BehaviorSubject<TableDialogModel>(null);

  public TableOpportunityDialogSubject = new Subject<TableDialogModel>();
  public TableOpportunityDialogSelectedSubject = new BehaviorSubject<TableDialogModel>(null);

  public showDialog(data: TableDialogModel) {
    this.TableDialogSubject.next(data);
  }

  public select(data: TableDialogModel) {
    this.TableTabSelectedSubject.next(data);
  }

  public showDialogOpportunity(data: TableDialogModel) {
    this.TableOpportunityDialogSubject.next(data);
  }

  public selectOpportunity(data: TableDialogModel) {
    this.TableOpportunityDialogSelectedSubject.next(data);
  }
}
